export const addOrReplaceItemInArray = (array, addedItem, comparedField = "id") => {
  if (!array) return null;
  if (array.find((item) => item[comparedField] === addedItem[comparedField])) {
    return array.map((item) => item[comparedField] === addedItem[comparedField] ? addedItem : item);
  }
  return [...array, addedItem];
};